import { MantineTheme } from "@mantine/styles";

import { ThemeComponent } from "./helpers.ts";

const baseSwitch = () => ({
  thumb: {
    cursor: "pointer",
  },
  track: {
    cursor: "pointer",
  },
});

const yellowSwitch = (theme: MantineTheme) => ({
  ...baseSwitch(),
  root: {
    "input:checked+.mantine-Switch-track": {
      background: theme.colors.golden[0],
      borderColor: "transparent",
    },
  },
});

const blueSwitch = (theme: MantineTheme) => ({
  ...baseSwitch(),
  root: {
    "input:checked+.mantine-Switch-track": {
      background: theme.colors.dusk[0],
      borderColor: "transparent",
    },
  },
});

export default function switchTheme(): ThemeComponent {
  return {
    variants: {
      yellow: yellowSwitch,
      blue: blueSwitch,
    },
  };
}
